import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { PackageCheckIcon } from "@jti/brand-icons/package-check";
import { PackageCrossIcon } from "@jti/brand-icons/package-cross";
import { StoreDefaultIcon } from "@jti/brand-icons/store-default";
import { Box } from "@jti/core-components/components/Box";
import type { MagentoStockStatus } from "@jti/magento-types";
import { DEPRECATED_Loading } from "@jti/ui/components/DEPRECATED_Loading";
import { useTranslations } from "@jti/ui/providers/useTranslations";

const { sanitize } = dompurify;

export type StockStatusType = {
  stockStatus: MagentoStockStatus;
  isProductDataLoading: boolean;
};

export const StockInformationBlock = ({ stockStatus }: Pick<StockStatusType, "stockStatus">) => {
  const { __ } = useTranslations();
  const rootClassName = "product-information-block__stock";

  if (stockStatus === "OUT_OF_STOCK") {
    return (
      <div className={classNames(rootClassName, `${rootClassName}--out-of-stock`)} data-testid="outOfStockBlock">
        <PackageCrossIcon />
        <span className={`${rootClassName}--stock-text`}>{sanitize(__("product.label.outofstock"))}</span>
      </div>
    );
  }

  if (stockStatus === "AVAILABLE_IN_STORES") {
    return (
      <div className={classNames(rootClassName, `${rootClassName}--in-stock`)} data-testid="availableInStoresBlock">
        <StoreDefaultIcon />
        <span className={`${rootClassName}--stock-text`}>{sanitize(__("product.label.availableinstores"))}</span>
      </div>
    );
  }

  return (
    <div className={classNames(rootClassName, `${rootClassName}--in-stock`)} data-testid="inStockBlock">
      <PackageCheckIcon />
      <span className={`${rootClassName}--stock-text`}>{sanitize(__("product.label.instock"))}</span>
    </div>
  );
};

export const StockStatus = ({ stockStatus, isProductDataLoading }: StockStatusType) => {
  const { __ } = useTranslations();
  return (
    <Box title={__("product.label.stock")}>
      {isProductDataLoading ? <DEPRECATED_Loading /> : <StockInformationBlock stockStatus={stockStatus} />}
    </Box>
  );
};
